module.exports = __webpack_public_path__ + "img/sld_scb_26_t1_b1_green.6acd5cca.svg";